import { render } from "./FAQS.vue?vue&type=template&id=93ee1696"
import script from "./FAQS.vue?vue&type=script&lang=js"
export * from "./FAQS.vue?vue&type=script&lang=js"

import "./FAQS.vue?vue&type=style&index=0&id=93ee1696&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__